import React from 'react';
import { useTranslation } from 'react-i18next';
import { getDayTypeLabel } from '../../utils/dayTypeDetector';
import { getDayLabels, isGoldDay } from '../../utils/minyanDay';
import { getCalendarTags } from '../../utils/calendarTags';

/** The day's labels ("Shabbos · Chanukah") plus calendar-only labels (e.g. Shabbat Zachor), gold or blue. */
export default function DayLabels({ date }: { date: string }) {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'he' ? 'he' : 'en';
  const gold = isGoldDay(date);
  const main = getDayLabels(date).map((l) => getDayTypeLabel(l, lang)).join(' · ');
  const extra = getCalendarTags(date, lang);
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <span
        className={`inline-block text-xs px-2.5 py-1 rounded-[10px] font-medium ${
          gold ? 'bg-gold-50 text-gold-700' : 'bg-weekday-50 text-weekday-700'
        }`}
      >
        {main}
      </span>
      {extra.map((tag) => (
        <span key={tag} className="inline-block text-xs px-2 py-0.5 rounded-[10px] border border-ink/10 text-ash">
          {tag}
        </span>
      ))}
    </span>
  );
}
